export default {
  siteservice: 'Global Services: Field Service',
  siteservicetext: `
  We are customer-centric and listen to customer needs. We have built a professional local technical team, providing full-lifecycle services and solutions for products. With professional and efficient services, we consistently exceed customer expectations and create greater value for clients.
  `,
  engineer: 'Technical Service Engineer',
  provider: ' Global Authorized Service Provider',
  network: 'Service Outlets / Service Network',
  storage: 'Warehouse Area / Storage Area',

  support: 'Original Factory Technical Support',
  Local: 'Localized Services',
  global: 'Global Allocation of Expert Resources',

  s1: 'Empowered by original technology, escorted by full-process after-sales service, one-on-one original factory technical support to solve problems accurately',
  s2: 'Deeply rooted in the local market, we build a comprehensive localized service system, arrange service outlets nearby and set up a professional local technical team',
  s3: 'Adopting a service model with global vision and local implementation, we accurately tackle various technical challenges and provide customers with high-standard professional support',

  Remote: 'Global Services: Remote Service',
  Remotetext: `Relying on a cloud-based technical architecture, we build a world-class remote service system.We enable seamless cross-region connection without the constraints of time and distance, providing professional online operation and maintenance, technical support, system commissioning and dedicated consulting services.With efficient response, real-time collaboration and full-process controllability, we deliver stable, reliable and high-quality one-stop remote solutions for customers at home and abroad through standardized processes and professional capabilities. `,

  online: 'Service Online',
  online24: '24/7 Online Remote Support Service',
  guidance: 'Real-time Operation Guidance',
  thoroughly:
    'Technicians provide real-time guidance anytime to solve all on-site problems.',
  equipment: 'Equipment Commissioning',
  schedule: 'Professional equipment commissioning by technical personnel',

  training: 'On-site Training',
  operation: 'Provide on-site training based on on-site practical operation',
};
